import LineItemFormTab from '@/Enums/CampaignManagement/LineItemFormTab.enum';
import GeoType from '@/Enums/Geography/GeographyType.enum';
import AudienceTargetingService from '@/Services/AudienceTargeting.service';
import { LINE_ITEM_TABS } from '@/pages/CampaignManagement/CreateCampaign/LineItemForm/constants/lineItemTabs.ts';

export const getDirtyTabs = formData =>
  LINE_ITEM_TABS.filter(tab => {
    switch (tab) {
      case LineItemFormTab.Basic:
        return formData.name && formData.impressionsBooked;
      case LineItemFormTab.Geo:
        return formData.geo?.included?.length || formData.geo?.excluded?.length;
      case LineItemFormTab.Audience:
        return Object.values(formData.audiences ?? {}).some(audiences =>
          AudienceTargetingService.checkAudiencesInTargeting(audiences),
        );
      case LineItemFormTab.Daypart:
        return Object.keys(formData.daypart).length;
      case LineItemFormTab.Creatives:
        return !!formData?.creatives?.length;
      case LineItemFormTab.DealGroups:
        return !!formData?.dealGroups?.length;
      default:
        return false;
    }
  });

export const isLocationOptionEqualToValue = (option, selectValue) => {
  if (!option || !selectValue) {
    return false;
  }

  if (option.type === GeoType.Zip) {
    return option.apiName === selectValue.apiName;
  }

  return option.id === selectValue.id;
};
